import React, { useState } from 'react';
import { CellProps } from 'react-table';
import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
import CobuTableAdvanced from '~/components/CobuTableAdvanced/CobuTableAdvanced';
import Spacer from '~/components/Spacer/Spacer';
import Spinner from '~/components/Spinner/Spinner';
import CobuConstants from '~/helpers/cobuConstants';
import styles from './ActiveUniversalButtons.module.css';
import GenericModal from '~/components/GenericModal/GenericModal';
import { getCreateUniversalButtonFormConfig } from '~/helpers/formHelpers';
import CreateUniversalButtonForm from '~/components/CreateUniversalButtonForm/CreateUniversalButtonForm';
import useUniversalButtons from '~/hooks/universalButtons/useUniversalButtons';
import {
  CreateUniversalButtonBody,
  UniversalButton
} from '~/types/universalButton';
import { useHistory } from 'react-router-dom';

export const ActiveUniversalButtons = () => {
  const {
    activeUniversalButtons,
    loadingConfig,
    deactivateUniversalButton,
    createUniversalButton,
    updateUniversalButton
  } = useUniversalButtons();
  const [showUniversalButtonCreateModal, setShowUniversalButtonCreateModal] =
    useState<boolean>(false);
  const [universalButtonToEdit, setUniversalButtonToEdit] =
    useState<UniversalButton | null>(null);
  const history = useHistory();

  const activeUniversalButtonTableConfig = [
    {
      Header: 'BUILDING',
      accessor: 'buildingName'
    },
    {
      Header: 'TITLE',
      accessor: 'buttonTitle',
      Cell: (cell: CellProps<UniversalButton>) => {
        return (
          <div style={{ whiteSpace: 'normal' }} className='default-text'>
            {cell.row.original.buttonTitle}
          </div>
        );
      }
    },
    {
      Header: 'LINK URL',
      Cell: (cell: CellProps<UniversalButton>) => {
        return (
          <a
            href={cell.row.original.linkURL}
            target='_blank'
            className='default-text'
          >
            {cell.row.original.linkType === 'External'
              ? 'View External Link'
              : cell.row.original.linkURL}
          </a>
        );
      }
    },
    {
      Header: 'TYPE',
      accessor: 'linkType',
      Cell: (cell: CellProps<UniversalButton>) => {
        return (
          <div style={{ whiteSpace: 'normal' }} className='default-text'>
            {cell.row.original?.linkType}
          </div>
        );
      }
    },
    {
      id: 'deactivate',
      Cell: (cell: CellProps<UniversalButton>) => (
        <div
          className={'more-actions-btn more-actions-btn-unselected pointer'}
          onClick={() => {
            deactivateUniversalButton(cell.row.original);
          }}
        >
          {CobuConstants.activeUniversalButtons.deactivateButton}
        </div>
      )
    },
    {
      id: 'editButton',
      Cell: (cell: CellProps<UniversalButton>) => (
        <div
          className={'more-actions-btn more-actions-btn-unselected pointer'}
          onClick={() => {
            const {building, uuid} = cell.row.original
            history.push(`/building/${building}/universal-button/${uuid}`);
          }}
        >
          {CobuConstants.activeUniversalButtons.manageButton}
        </div>
      )
    }
  ];

  const getCobuTableInstance = (
    data: UniversalButton[],
    placeholder: string
  ) => {
    return (
      <CobuTableAdvanced
        columns={activeUniversalButtonTableConfig}
        data={data}
        noData={{
          label: placeholder,
          action: undefined,
          image: undefined
        }}
        actions={[createUniversalButtonAction()]}
        actionsStyle={{ top: '130px' }}
      />
    );
  };

  const createUniversalButtonAction = () => {
    return (
      <button
        className='btn-primary btn-standard bold'
        onClick={() => {
          setUniversalButtonToEdit(null);
          setShowUniversalButtonCreateModal(!showUniversalButtonCreateModal);
        }}
      >
        {CobuConstants.activeUniversalButtons.createButton}
      </button>
    );
  };

  if (loadingConfig.flag)
    return (
      <div className={styles.loadingContainer}>
        <Spinner />
        <h3 style={{ textAlign: 'center' }}>{loadingConfig.comment}</h3>
      </div>
    );

  const createUniversalButtonModal = () => {
    return showUniversalButtonCreateModal ? (
      <GenericModal
        showModal={showUniversalButtonCreateModal}
        title={CobuConstants.activeUniversalButtons.createButton}
        content={
          <CreateUniversalButtonForm
            cancel={() => {
              setUniversalButtonToEdit(null);
              setShowUniversalButtonCreateModal(
                !showUniversalButtonCreateModal
              );
            }}
            createUniversalButton={(button: CreateUniversalButtonBody) => {
              setShowUniversalButtonCreateModal(
                !showUniversalButtonCreateModal
              );
              createUniversalButton(button);
            }}
            updateUniversalButton={(button: CreateUniversalButtonBody) => {
              setShowUniversalButtonCreateModal(
                !showUniversalButtonCreateModal
              );
              updateUniversalButton(button);
              setUniversalButtonToEdit(null);
            }}
            formConfig={getCreateUniversalButtonFormConfig()}
            defaultData={universalButtonToEdit}
          />
        }
        hideActionButton
        canceActionButton
        actionText={CobuConstants.residentManagement.createActionTitle}
        actionFunction={() => {}}
        onChange={() => {}}
      />
    ) : null;
  };

  return (
    <div className='content-container'>
      <Breadcrumbs />
      <Spacer height={20} />
      <h1>{CobuConstants.activeUniversalButtons.title}</h1>
      <Spacer height={20} />
      {getCobuTableInstance(
        activeUniversalButtons,
        CobuConstants.activeUniversalButtons.noActiveButtons
      )}
      {createUniversalButtonModal()}
    </div>
  );
};
